// src/hooks/usePageContent.js
import { useState } from 'react';
import { uploadInvoiceProof } from '../services/paymentService';

const useSendInvoiceProof = () => {
    const [status, setStatus] = useState('idle'); // idle | loading | done | error
    const [error, setError] = useState('');
    const [redirect, setRedirect] = useState([]);
    const [data, setData] = useState({});


    const sendUploadProof = async (invoiceId, image) => {
        setStatus('loading');
        setError('');

        try {
            const response = await uploadInvoiceProof(invoiceId, image);

            if (response?.status === 200) {
                setData(response.data);
                setStatus('done');
            } else {
                setStatus('error');
                setError(response?.message || 'Something went wrong');
            }
        } catch (err) {
            setStatus('error');
            setError(err?.message || 'Something went wrong');
        }
    };

    const resetStatus = () => {
        setStatus('idle');
        setError('');
    };

    return {
        sendUploadProof,
        data,
        redirect,
        status,
        error,
        resetStatus
    };
};

export default useSendInvoiceProof;
